import React from 'react';
import ShowQuery from 'queries/inspection_subject/show';
import ShowItem from 'components/inspection_subject/show_item';
import InspectionsContainer from 'components/inspection/index_container';
import BreadcrumbContainer from 'components/layout/breadcrumb_container';
import TopMenu from 'components/layout/top_menu';
import LoaderContainer from 'components/layout/loader_container';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { useParams, useNavigate } from 'react-router-dom';
import { InspectionSubjectsLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import {
  BreadCrumbTypography,
  CardOptionTypography,
} from 'components/styles_components/typography';
import { PaginateProvider } from 'contexts/paginate';
import { WhiteCard } from 'components/styles_components/card';
import { Grid } from 'components/ui';

const Show = () => {
  const setError = useError();
  const navigate = useNavigate();
  const { inspectionSubjectId } = useParams();
  const {
    data = {
      space: {},
      inspectionSubject: { adminRole: true, inspectionsTotal: 0, place: {} },
      initLoading: true,
    },
    loading,
    error,
    refetch,
  } = useQuery(ShowQuery, {
    variables: { id: inspectionSubjectId },
    onError: () => {
      setError('error.inspection_subject.show');
      navigate(InspectionSubjectsLink());
    },
  });

  return (
    <>
      <TopMenu>
        <BreadcrumbContainer>
          <BreadCrumbLink to={InspectionSubjectsLink()}>
            <FormattedMessage id="breadcrumb.inspection_subjects.index" />
          </BreadCrumbLink>
          <BreadCrumbTypography>{data.inspectionSubject.name}</BreadCrumbTypography>
        </BreadcrumbContainer>
      </TopMenu>
      <LoaderContainer loading={loading} error={error} keepRenderedContent={!data.initLoading}>
        <ShowItem inspectionSubject={data.inspectionSubject} space={data.space} refetch={refetch} />
        <Grid spacing={2} sx={{ mt: 2 }}>
          <WhiteCard>
            <CardOptionTypography>
              <FormattedMessage id="inspection.count" />
            </CardOptionTypography>
            <PaginateProvider key="inspections-tab">
              <InspectionsContainer
                showTitle={false}
                placeId={data.inspectionSubject.place.id}
                inspectionSubjectId={inspectionSubjectId}
              />
            </PaginateProvider>
          </WhiteCard>
        </Grid>
      </LoaderContainer>
    </>
  );
};

export default Show;
